module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CheckInDetailView.js"));
	}, "CheckInDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CheckInDetailView!./src/pages/Promote/OfflineActivity/CheckIn/CheckInDetail/CheckInDetailView.js
// module id = 1181
// module chunks = 431